import { atom } from "jotai";

export const aboutModalOpenAtom = atom(false);
